(function () {

    "use strict";

    angular
        .module("harriApp")
        .service("platformNavigatorService", PlatformNavigatorService);
    PlatformNavigatorService.$inject = ['$state', 'hUser', 'brandServices', 'userPermissions'];

    function PlatformNavigatorService($state, hUser, brandServices, userPermissions) {
        var self = this;

        /**
         * Retrieves dashboard brand link details.
         * @async
         * @returns {Promise<Object>} A promise that resolves to an object that contains brand name and group id.
         */
        self.getDashboardLinkBrandDetails = async () => {
            try {
                let brandInfoId;
                let groupId;
                const accessType = await brandServices.getBrandAccessType(hUser.getUserContext().brand_id);

                if (
                    hUser.data.user.brands_list &&
                    hUser.data.user.brands_list.length === 1
                ) {
                    brandInfoId = hUser.data.user.brands_list[0].id;
                } else if (accessType === 'PASS') {
                    brandInfoId = hUser.getActiveBrandId();
                } else {
                    brandInfoId = hUser.getUserContext().brand_id;
                    groupId = hUser.getUserContext().brand_id;
                }

                const brandInfo = await BrandAPI.getBrandBasicInfo(brandInfoId);

                return {groupId: groupId, brandName: brandInfo.name};
            } catch (err) {
                console.error(err);
            }
        };

        self.handleLogInAccessRedirection = async (toStateName) => {
            try {
                if (!hUser.getUserContext()?.brand_id) {
                    await hUser.init();
                }

                if (hUser.isTopLevelContext()) {
                    return;
                }

                const userContext = hUser.getUserContext();
                const policyParser = await userPermissions.getBrandPolicy(userContext.brand_id);
                const hasAccessToSourceHire = policyParser.hasAccess(userPermissions.ACCESS_TYPES.SOURCE_HIRE);
                const hasAccessToTeam = policyParser.hasAccess(userPermissions.ACCESS_TYPES.TEAM);

                if (toStateName.indexOf("appLayout.schedule.") > -1 && !hasAccessToTeam) {
                    Utils.redirectToWorkspace('homepage');
                }

                if (
                    !hasAccessToSourceHire &&
                    toStateName.indexOf("appLayout.schedule.") === -1 &&
                    toStateName.indexOf("print-schedule") === -1 &&
                    toStateName.indexOf('appLayout.harriSH.dashboard') === -1 &&
                    toStateName.indexOf("appLayout.harriSH.harri-iq") === -1 &&
                    toStateName.indexOf("appLayout.harriSH.access-portal") === -1 &&
                    toStateName.indexOf("job-post") === -1 &&
                    toStateName.indexOf("redirect-to-support") === -1 &&
                    toStateName.indexOf("appLayout.harriSH.dashboards-main-gp") === -1 &&
                    toStateName.indexOf("appLayout.harriSH.adam") === -1 &&
                    toStateName.indexOf("appLayout.harriSH.custom-dashboards") === -1 &&
                    toStateName.indexOf("appLayout.harriSH.communication-hub") === -1 &&
                    toStateName.indexOf("appLayout.harriSH.engagement-non-ratings") === -1 &&
                    toStateName.indexOf("appLayout.harriSH.engagement-ratings") === -1 &&
                    toStateName.indexOf("appLayout.harriSH.surveys") === -1 &&
                    toStateName.indexOf("appLayout.harriSH.globalSearch") === -1 &&
                    toStateName.indexOf("appLayout.harriSH.pms") === -1 &&
                    toStateName.indexOf("appLayout.harriSH.dashboards") === -1 &&
                    toStateName.indexOf("appLayout.harriSH.core-hr") === -1
                ) {
                    if (
                        hUser.isTeamSchedulingEnabled() &&
                        hasAccessToTeam
                    ) {
                        const params = {};
                        const [isTeamSchedulingEnabledOnActiveBrand, activeBrandAccessType] = await Promise.all([
                            brandServices.check(brandServices.SERVICES.TEAM_SCHEDULING, hUser.getActiveBrandId()),
                            brandServices.getBrandAccessType(hUser.getActiveBrandId()),
                        ]);

                        if (
                            isTeamSchedulingEnabledOnActiveBrand &&
                            activeBrandAccessType === brandServices.BRAND_ACCESS_TYPES.ACTIVE
                        ) {
                            params.brandId = hUser.getActiveBrandId();
                        }

                        $state.go('appLayout.schedule.main', params);
                    } else if (hUser.isHMAPUser()) {
                        Utils.redirectToWorkspace('appLayout.harriSH.access-portal.main');
                    } else {
                        Utils.redirectToWorkspace('homepage');
                    }
                }
            } catch (e) {
                console.error(e);
            }
        };
    }
})();